 export function getdata(){
	 let obj = {
		 	searchlist: [{
		 			prop: "nsrmc",
		 			label: '纳税人名称',
		 			type: "input"
		 		},
		 		{
		 			prop: "nsrsbh",
		 			label: '纳税人识别号',
		 			type: "input"
		 		},
		 		{
		 			prop: "shujly",
		 			label: '数据来源',
		 			type: "select",
		 			selectval:[{ 
		 					label: "明细登记",
		 					value: "3"
		 				},{ 
		 					label: "科目余额表",
		 					value: "1"
		 				},]
		 		},
		 		{
		 			prop: "shenbzq",
		 			label: '申报周期',
		 			type: "select",
		 			selectval:[{
		 					label: "按季申报",
		 					value: "2"
		 				},{ 
		 					label: "按月申报",
		 					value: "1"
		 				},]
		 		},
		 	],
		 	headlyData:[
		 		{
		 			title: "映射规则编码",
		 			prop: "yingsbm",
		 			width:"100px"
		 		},
		 		{
		 			title: "相关公司",
		 			prop: "companyNames",
		 			custom: true,
		 			width:160,
		 			align:"left"
		 		},
		 		{
		 			title: "数据来源",
		 			prop: "shujly",
		 			custom:true,
		 			width:"350px"
		 		},
		 	],
		 	headData:[
		 		{
		 			title: "纳税人名称",
		 			prop: "nsrmc",
		 			custom:true,
		 			width: 100,
		 		},
		 		{
		 			title: "纳税人识别号",
		 			prop: "nsrsbh",
		 			custom:true,
		 			width: 100,
		 		},
		 		{
		 			title: "数据来源",
		 			prop: "shujly",
		 			custom:true,
		 			width: "160",AmountFormat:true,			
		 		},
		 		{
		 			title: "申报周期",
		 			prop: "shenbzq",
		 			width: "80",
		 			custom:true,
		 		},
		 		{
		 			title: "操作",
		 			prop: "cz",
		 			custom:true,
		 			width: "200"
		 		},
		 	],
		 	formdata:{
		 		nsrmc:'',
		 		shenbzq:'',
		 		suosq:'',
		 		firstNum:'',
		 		lastNum:'',
		 		cyryId:'',
		 		shenbname:'',
		 		e:null,
		 	},
		 	formlist:[
		 		{
		 			prop: "nsrmc",
		 			label: "纳税人名称",
		 			type: "input",
		 			width:"220px",
		 			istosee:true,
		 		},
		 		{
		 			prop: "shenbname",
		 			label: "申报周期",
		 			type: "input",
		 			width:"220px",
		 			istosee:true,
		 		},{
		 			prop: "suosq",
		 			label: "所属季度",
		 			type: "select",
		 			width:"220px",
		 			selectchange:true,
		 			selectval:[]
		 		},{
		 			prop: "firstNum",
		 			label: "季初从业人数",
		 			type: "input",
		 			width:"220px",
		 		},{
		 			prop: "lastNum",
		 			label: "季末从业人数",
		 			type: "input",
		 			width:"220px",
		 		}
		 	],
		 	pagination:{
		 		pageNum: 1,
		 		pageSize: 10,
		 		total: 0,
		 		paginationkey:0
		 	},
		 	lypagination:{
		 		pageNum: 1,
		 		pageSize: 50,
		 		total: 0,
		 		paginationkey:0
		 	},
		 	searchdata:{
		 		nsrmc:"",
		 		nsrsbh:"",
		 		sjly:'',
		 		shenbzq:'',
		 		nianf:"",
		 	},
		 	json:"{\n" +
		     "  \"searchList\":[\n" +
		     "    {\n" +
		     "      \"name\":\"纳税人名称\",\n" +
		     "      \"column\":\"nsrmc\",\n" +
		     "      \"originName\":\"纳税人名称\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"纳税人识别号\",\n" +
		     "      \"column\":\"nsrsbh\",\n" +
		     "      \"originName\":\"纳税人识别号\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"公司编号\",\n" +
		     "      \"column\":\"company_no\",\n" +
		     "      \"originName\":\"公司编号\",\n" +
		     "      \"show\":\"1\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"年份\",\n" +
		     "      \"column\":\"nianf\",\n" +
		     "      \"originName\":\"年份\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"数据来源\",\n" +
		     "      \"column\":\"shujly\",\n" +
		     "      \"originName\":\"数据来源\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"申报周期\",\n" +
		     "      \"column\":\"shenbzq\",\n" +
		     "      \"originName\":\"申报周期\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"创建时间\",\n" +
		     "      \"column\":\"create_time\",\n" +
		     "      \"originName\":\"创建时间\",\n" +
		     "      \"show\":\"1\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"修改时间\",\n" +
		     "      \"column\":\"update_time\",\n" +
		     "      \"originName\":\"修改时间\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"操作人\",\n" +
		     "      \"column\":\"update_by\",\n" +
		     "      \"originName\":\"操作人\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "  ],\n" +
		     "  \"headData\":[\n" +
		     "    {\n" +
		     "      \"name\":\"纳税人名称\",\n" +
		     "      \"column\":\"nsrmc\",\n" +
		     "      \"originName\":\"纳税人名称\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"纳税人识别号\",\n" +
		     "      \"column\":\"nsrsbh\",\n" +
		     "      \"originName\":\"纳税人识别号\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"公司编号\",\n" +
		     "      \"column\":\"company_no\",\n" +
		     "      \"originName\":\"公司编号\",\n" +
		     "      \"show\":\"1\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"年份\",\n" +
		     "      \"column\":\"nianf\",\n" +
		     "      \"originName\":\"年份\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"数据来源\",\n" +
		     "      \"column\":\"shujly\",\n" +
		     "      \"originName\":\"数据来源\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"申报周期\",\n" +
		     "      \"column\":\"shenbzq\",\n" +
		     "      \"originName\":\"申报周期\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"创建时间\",\n" +
		     "      \"column\":\"create_time\",\n" +
		     "      \"originName\":\"创建时间\",\n" +
		     "      \"show\":\"1\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"修改时间\",\n" +
		     "      \"column\":\"update_time\",\n" +
		     "      \"originName\":\"修改时间\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"操作人\",\n" +
		     "      \"column\":\"update_by\",\n" +
		     "      \"originName\":\"操作人\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "  ],\n" +
		     "  \"formlist\":[\n" +
		     "    {\n" +
		     "      \"name\":\"纳税人名称\",\n" +
		     "      \"column\":\"nsrmc\",\n" +
		     "      \"originName\":\"纳税人名称\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"纳税人识别号\",\n" +
		     "      \"column\":\"nsrsbh\",\n" +
		     "      \"originName\":\"纳税人识别号\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"公司编号\",\n" +
		     "      \"column\":\"company_no\",\n" +
		     "      \"originName\":\"公司编号\",\n" +
		     "      \"show\":\"1\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"年份\",\n" +
		     "      \"column\":\"nianf\",\n" +
		     "      \"originName\":\"年份\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"数据来源\",\n" +
		     "      \"column\":\"shujly\",\n" +
		     "      \"originName\":\"数据来源\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"申报周期\",\n" +
		     "      \"column\":\"shenbzq\",\n" +
		     "      \"originName\":\"申报周期\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"创建时间\",\n" +
		     "      \"column\":\"create_time\",\n" +
		     "      \"originName\":\"创建时间\",\n" +
		     "      \"show\":\"1\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"修改时间\",\n" +
		     "      \"column\":\"update_time\",\n" +
		     "      \"originName\":\"修改时间\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "    {\n" +
		     "      \"name\":\"操作人\",\n" +
		     "      \"column\":\"update_by\",\n" +
		     "      \"originName\":\"操作人\",\n" +
		     "      \"show\":\"0\"\n" +
		     "    },\n" +
		     "  ]\n" +
		     "}"
		 
	 }
	 return obj
 }
